<template>
    <div>
        <!--Header-->
	    <div class="w-full p-0 m-0 bg-bottom">
            <div v-if="loggedIn" class="absolute right-0 py-2 my-2 sm:px-6 lg:px-8">
                <Menu />
            </div>
            <div v-else>
                <ModalLogin />
                <ModalRegister />
            </div>
			<div class="w-screen pt-8 pb-32 mx-auto text-center break-normal bg-live-blue">
				<!--Title-->
				<router-link :to="{ name: 'Home' }">
					<img class="w-1/3 mx-auto" src="@/assets/logo.svg" alt="Live@Home Logo">
					<!-- <p class="text-3xl font-extrabold text-white md:text-5xl">live@home</p> -->
					<!-- <p class="text-xl text-white text-gray-900 md:text-2xl">Deine Künstler im Livestream</p> -->
				</router-link>
                
			</div>
            
		</div>
        
    </div>
</template>

<script>
    import * as firebase from "firebase/app";
    import "firebase/auth";
    
    import Menu from "@/components/Menu";
    import ModalLogin from "@/components/ModalLogin";
    import ModalRegister from "@/components/ModalRegister";

    export default {
        data() {
            return {
                loggedIn: false
            }
        },
        created(){
            firebase.auth().onAuthStateChanged(user => {
                this.loggedIn = !!user;
            })
        },
        components: {
            Menu,
            ModalLogin,
            ModalRegister
        },
        props: {
            
        },
        
    }
</script>

<style lang="scss" scoped>

</style>